import { IGetAllTreinamentoFuncionarioAssinaturaUseCase } from "../../../presentation/useCases/read/get_all_treinamento_funcionario_assinatura_use_case";
import { TreinamentoFuncionarioAssinatura } from "../../models/treinamento_funcionario_assinatura";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetAllTreinamentoFuncionarioAssinaturaUseCase
 */

export class GetAllTreinamentoFuncionarioAssinaturaUseCase implements IGetAllTreinamentoFuncionarioAssinaturaUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getAllTreinamentoFuncionarioAssinatura(): Promise<TreinamentoFuncionarioAssinatura[]> {
    return this.repository.getAllTreinamentoFuncionarioAssinatura();
  }
}
